import React from 'react'

const Quality=()=> {
  return (
    <div>
              <div class="quality">
        <div class="quality__head">
          <div class="quality__center center">
            <div class="quality__top" data-aos="animation-scale-y">
              <div class="quality__stage stage">Effortless</div>
              <h2 class="quality__title title">Go from ideation to <br/>design and implementation<span class="title__color">.</span></h2>
            </div>
            <div class="quality__info info" data-aos="animation-scale-y" data-aos-delay="200">Reach us to easily transform your Company to an advanced technological hub fully customised to your needs.</div>
          </div>
          <div class="quality__line"><img class="quality__pic" src="img/line-3.svg" alt=""/></div>
          <div class="quality__preview"><img class="quality__pic js-parallax" data-scale="1.2" data-orientation="left" src="img/lamp.png" alt=""/></div>
        </div>
        <div class="quality__body">
          <div class="quality__col">
            <div class="quality__item" data-aos="animation-scale-x-left">
              <div class="quality__icon"><img class="quality__pic" src="img/camera-big.png" alt=""/></div>
              <div class="quality__details">
                <div class="quality__category">Research Rich</div>
                <div class="quality__text">Our approach is proven Research oriented , implying our solution will definately work for you..</div><a class="quality__link" href="#">Learn more<svg class="icon icon-arrow-right">
                    <use xlinkHref="img/sprite.svg#icon-arrow-right"></use>
                  </svg></a>
              </div>
            </div>
          </div>
          <div class="quality__col">
            <div class="quality__item" data-aos="animation-scale-x-right" data-aos-delay="200">
              <div class="quality__icon"><img class="quality__pic" src="img/clock-big.png" alt=""/></div>
              <div class="quality__details">
                <div class="quality__category">Save Time</div>
                <div class="quality__text">Our able team uses advanced paradigms to deliver our promise right on time. </div><a class="quality__link" href="#">Learn more<svg class="icon icon-arrow-right">
                    <use xlinkHref="img/sprite.svg#icon-arrow-right"></use>
                  </svg></a>
              </div>
            </div>
          </div>
          <div class="quality__col">
            <div class="quality__item" data-aos="animation-scale-x-left">
              <div class="quality__icon"><img class="quality__pic" src="img/cup-big.png" alt=""/></div>
              <div class="quality__details">
                <div class="quality__category">Relax</div>
                <div class="quality__text">Let our personalized professionals do the heavy lifting while you,Say good bye to hustles 👋</div><a class="quality__link" href="#">Learn more<svg class="icon icon-arrow-right">
                    <use xlinkHref="img/sprite.svg#icon-arrow-right"></use>
                  </svg></a>
              </div>
            </div>
          </div>
          <div class="quality__col">
            <div class="quality__item" data-aos="animation-scale-x-right" data-aos-delay="200">
              <div class="quality__icon"><img class="quality__pic" src="img/chatbox-big.png" alt=""/></div>
              <div class="quality__details">
                <div class="quality__category">Support</div>
                <div class="quality__text">Got stuck or need any help? Our support team is online 24/7 to help assist you with any issues.</div><a class="quality__link" href="#">Learn more<svg class="icon icon-arrow-right">
                    <use xlinkHref="img/sprite.svg#icon-arrow-right"></use>
                  </svg></a>
              </div>
            </div>
          </div>
        </div>
        <div class="quality__circles">
          <div class="quality__circle"> </div>
          <div class="quality__circle"> </div>
        </div>
      </div>
    </div>
  )
}

export default Quality